import React from 'react';
import { Outlet } from 'react-router-dom';
import useSidebar from '../../hooks/useSidebar';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

const AppShell = () => {
  const { collapsed, toggleCollapse, mobileOpen, openMobile, closeMobile, openSubmenus, toggleSubmenu } =
    useSidebar();

  // The layout plugin positions the header, container and footer with sibling
  // combinators off `.pc-sidebar`, so these four must stay flat siblings.
  return (
    <>
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onClose={closeMobile}
        openSubmenus={openSubmenus}
        toggleSubmenu={toggleSubmenu}
      />
      <Header onToggleCollapse={toggleCollapse} onOpenMobile={openMobile} />
      <div className="pc-container">
        <div className="pc-content">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AppShell;
